import * as React from 'react';
import Page from 'components/Page';
import { Button, Row, Col } from 'reactstrap';
import { MdAdd, } from 'react-icons/lib/md';
import ParkingSpotCreate from 'components/ParkingSpotCreate';
import DynamicTable from 'components/DynamicTable';
import DeleteModal from 'components/DeleteModal';
import { connect } from 'react-redux';
import * as loginSelectors from 'store/login/reducer';

class ParkingSpotsPage extends React.Component{
  constructor(props){
    super(props)
    this.state = {
      show_form: false,
      show_deleting : false,
      columns : [
        {name: 'id', title: 'ID'},
        {name: 'spot_number', title: 'Vaga'},
        {name: 'address', title: 'Endereço', getCellValue: row => row.address+', n°'+row.address_number},
        {name: 'type', title: 'Tipo', getCellValue: row => row.type.name },
        {name: 'status', title: 'Status' , getCellValue: row => row.status.name},
      ],
      reload : false,
      editingObj : null,
      delete_id : -1
    };
    this.addAction =this.addAction.bind(this);
    this.closed =this.closed.bind(this);
    this.closedDelete =this.closedDelete.bind(this);
    this.editAction =this.editAction.bind(this);
    this.deleteAction =this.deleteAction.bind(this);
  }
  addAction(){
    this.setState({ show_form : !this.state.show_form})
  }
  closed(refresh){
    if(refresh){
      this.setState({ show_form : false, reload : !this.state.reload, editingObj : null} )
    }else{
      this.setState({ show_form : false, editingObj : null})
    }
  }
  closedDelete(refresh){
    if(refresh){
      this.setState({ show_deleting : false, reload : !this.state.reload, delete_id : -1} )
    }else{
      this.setState({ show_deleting : false , delete_id : -1})
    }
  }
  editAction(idx, obj){
    this.setState({ show_form : true , editingObj : obj})
  }
  deleteAction(idx, obj){
    this.setState({ show_deleting : true , delete_id : obj.id})
  }
  render() {
    return (
      <Page 
        title="Vagas"
        className="ParkingSpotsPage">
        <Row>
          <Col>
            <Button outline onClick={this.addAction}><MdAdd size={25} /> Adicionar</Button>
          </Col>
        </Row>
        <DynamicTable
          user={this.props.user}
          api="admin/parking-spot"
          columns={this.state.columns}
          dateFilter="false"
          integratedFilter="false"
          currencyColumns="false"
          showPagingState="false"
          filterState="false"
          integratePag="false"
          deleteAction={this.deleteAction}
          editAction={this.editAction}
          reload={this.state.reload}
        />
        <ParkingSpotCreate
          visible={this.state.show_form}
          user={this.props.user}
          toggle={this.closed}
          editing={this.state.editingObj}
        />
        <DeleteModal
          visible={this.state.show_deleting}
          user={this.props.user}
          toggle={this.closedDelete}
          api="admin/parking-spot/"
          value={this.state.delete_id}
        />
      </Page>
    );
  }
};

// which props do we want to inject, given the global store state?
function mapStateToProps(state) {
  const currentUser = loginSelectors.getUser(state);
  return {
    user : currentUser
  };
}
export default connect(mapStateToProps)(ParkingSpotsPage);


// WEBPACK FOOTER //
// ./src/pages/ParkingSpotsPage.js